export default __webpack_public_path__ + "2c0bc6c75cfae9ae23433f40bbec2e2f.png";